(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-caps-studio-brand-led"] && !Shopify.designMode) return;
  try {
    
 (function() {
  function initCapsStudio(root) {
    if (!root || root.dataset.capsStudioReady === 'true') return;

    root.dataset.capsStudioReady = 'true';

    root.addEventListener('click', function(event) {

      const capabilityTab = event.target.closest(
        '.ccs-spec__tab, .ccs-spec__thumb, .ccs-spec__mobile-tab'
      );

      if (capabilityTab && root.contains(capabilityTab)) {
        const index = capabilityTab.dataset.capabilityIndex;

        root.querySelectorAll(
          '.ccs-spec__tab, .ccs-spec__thumb, .ccs-spec__mobile-tab'
        ).forEach(function(button) {
          const active = button.dataset.capabilityIndex === index;

          button.classList.toggle('is-active', active);
          button.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );
        });

        root.querySelectorAll(
          '.ccs-spec__panel, .ccs-spec__mobile-panel'
        ).forEach(function(panel) {
          panel.classList.toggle(
            'is-active',
            panel.dataset.capabilityPanel === index
          );
        });

        const activeThumb = root.querySelector(
          '.ccs-spec__thumb[data-capability-index="' + index + '"]'
        );

        if (
          activeThumb &&
          window.matchMedia('(min-width: 750px)').matches
        ) {
          activeThumb.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }

        return;
      }

      const tab = event.target.closest('.ccs-audience__tab');

      if (tab && root.contains(tab)) {
        const index = tab.dataset.audienceIndex;

        root.querySelectorAll('.ccs-audience__tab').forEach(function(button) {
          const active = button.dataset.audienceIndex === index;

          button.classList.toggle('is-active', active);
          button.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );
        });

        root.querySelectorAll('.ccs-audience__panel').forEach(function(panel) {
          panel.classList.toggle(
            'is-active',
            panel.dataset.audiencePanel === index
          );
        });
      }
    });

    /* ADD THE BASIN FORM CODE HERE */
    const form = root.querySelector('.ccs-form');
    const successMessage = root.querySelector('.ccs-form-success');

    if (form && successMessage) {
      form.addEventListener('submit', async function(event) {
        event.preventDefault();

        if (form.classList.contains('is-submitting')) return;

        const submitButton = form.querySelector('[type="submit"]');
        const originalButtonText = submitButton
          ? submitButton.textContent
          : '';

        form.classList.add('is-submitting');

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Sending...';
        }

        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: {
              Accept: 'application/json'
            }
          });

          if (!response.ok) {
            throw new Error('The form could not be submitted.');
          }

          form.reset();
          form.hidden = true;
          successMessage.hidden = false;

          successMessage.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          window.setTimeout(function() {
            successMessage.hidden = true;
            form.hidden = false;
            form.classList.remove('is-submitting');

            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = originalButtonText;
            }
          }, 8000);

        } catch (error) {
          form.classList.remove('is-submitting');

          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }

          window.alert(
            'Sorry, your enquiry could not be sent. Please check your details and try again.'
          );

          console.error('Custom caps form error:', error);
        }
      });
    }
  }

  document
    .querySelectorAll('[id^="CustomCapsStudio-"]')
    .forEach(initCapsStudio);

  document.addEventListener('shopify:section:load', function(event) {
    const root = event.target.querySelector(
      '[id^="CustomCapsStudio-"]'
    );

    initCapsStudio(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["financial-services-pack-landing"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(root) {
    if (!root || root.dataset.iplReady === 'true') return;
    root.dataset.iplReady = 'true';

    const revealItems = root.querySelectorAll('[data-reveal]');
    if (root.classList.contains('ipl--reveal') && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealItems.forEach(function(item) { observer.observe(item); });
    } else {
      revealItems.forEach(function(item) { item.classList.add('is-visible'); });
    }

    const progress = root.querySelector('.ipl-progress span');
    const sticky = root.querySelector('.ipl-sticky');
    const hero = root.querySelector('.ipl-hero');
    const finalCta = root.querySelector('.ipl-final-cta');

    function updatePageUi() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (progress) {
        const height = document.documentElement.scrollHeight - window.innerHeight;
        progress.style.width = (height > 0 ? Math.min(100, (scrollTop / height) * 100) : 0) + '%';
      }
      if (sticky && hero) {
        const heroBottom = hero.getBoundingClientRect().bottom;
        const finalVisible = finalCta && finalCta.getBoundingClientRect().top < window.innerHeight;
        const visible = heroBottom < 0 && !finalVisible;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        const link = sticky.querySelector('a');
        if (link) link.tabIndex = visible ? 0 : -1;
      }
    }

    updatePageUi();
    window.addEventListener('scroll', updatePageUi, { passive: true });
    window.addEventListener('resize', updatePageUi);
  }

  document.querySelectorAll('[id^="IndustryPackLanding-"]').forEach(init);
  document.addEventListener('shopify:section:load', function(event) {
    init(event.target.querySelector('[id^="IndustryPackLanding-"]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["industry-pack-landing"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(root) {
    if (!root || root.dataset.iplReady === 'true') return;
    root.dataset.iplReady = 'true';

    const revealItems = root.querySelectorAll('[data-reveal]');
    if (root.classList.contains('ipl--reveal') && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealItems.forEach(function(item) { observer.observe(item); });
    } else {
      revealItems.forEach(function(item) { item.classList.add('is-visible'); });
    }

    const progress = root.querySelector('.ipl-progress span');
    const sticky = root.querySelector('.ipl-sticky');
    const hero = root.querySelector('.ipl-hero');
    const finalCta = root.querySelector('.ipl-final-cta');

    function updatePageUi() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (progress) {
        const height = document.documentElement.scrollHeight - window.innerHeight;
        progress.style.width = (height > 0 ? Math.min(100, (scrollTop / height) * 100) : 0) + '%';
      }
      if (sticky && hero) {
        const heroBottom = hero.getBoundingClientRect().bottom;
        const finalVisible = finalCta && finalCta.getBoundingClientRect().top < window.innerHeight;
        const visible = heroBottom < 0 && !finalVisible;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        const link = sticky.querySelector('a');
        if (link) link.tabIndex = visible ? 0 : -1;
      }
    }

    updatePageUi();
    window.addEventListener('scroll', updatePageUi, { passive: true });
    window.addEventListener('resize', updatePageUi);
  }

  document.querySelectorAll('[id^="IndustryPackLanding-"]').forEach(init);
  document.addEventListener('shopify:section:load', function(event) {
    init(event.target.querySelector('[id^="IndustryPackLanding-"]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
